import request from '@/utils/request'

// 查询【客户等级】列表
export function listLevel(query) {
  return request({
    url: '/scrm/custLevel/list',
    method: 'get',
    params: query
  })
}

// 查询【客户等级】详细
export function getLevel(custLevelId) {
  return request({
    url: '/scrm/custLevel/' + custLevelId,
    method: 'get'
  })
}

// 新增【客户等级】
export function addLevel(data) {
  return request({
    url: '/scrm/custLevel',
    method: 'post',
    data: data
  })
}

// 修改【客户等级】
export function updateLevel(data) {
  return request({
    url: '/scrm/custLevel',
    method: 'put',
    data: data
  })
}

// 删除【客户等级】
export function delLevel(custLevelId) {
  return request({
    url: '/scrm/custLevel/' + custLevelId,
    method: 'delete'
  })
}

// 导出【客户等级】
export function exportLevel(query) {
  return request({
    url: '/scrm/custLevel/export',
    method: 'get',
    params: query
  })
}

// 查询所有【客户等级】
export function selectAllCustLevel(query) {
  return request({
    url: '/scrm/custLevel/selectAllCustLevel',
    method: 'get',
    params: query
  })
}


